import { useContext, useMemo } from 'react';

import { OverrideContext } from '../context/OverrideContext';

export const useOverride = () => {
  const registry = useContext(OverrideContext);
  if (!registry) {
    throw new Error('useOverride must be used within an OverrideProvider');
  }
  return useMemo(() => registry.createProxy(), [registry]);
};
